import { VFC } from 'react'
import { useMasterData } from 'src/api/masterData'
import { LIGHT_BLUB } from 'src/assets/images'
import { LoginUser, Solutions } from 'src/models/User'
import { _needs_form_light_blub, mediumGray } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { ProfileForm } from '../formComponents'
import { SolutionsSelect } from '../formComponents/SolutionsSelect'
import { ProfileEditorWrapper } from '../ProfileLayout'

type SolutionsFormProps = {
  user: LoginUser
  submit: (solutions: Solutions) => Promise<any>
}

export const SolutionsForm: VFC<SolutionsFormProps> = ({ user, submit }) => {
  const { data } = useMasterData()
  return (
    <ProfileEditorWrapper user={user} currentPath="ソリューションの編集">
      <ProfileForm
        title="ソリューションの編集"
        description={
          'あなたが応えることのできるソリューションを選択してください（複数選択可）'
        }
        user={user}
        propertyKey="solutions"
        submit={submit}
        displayTipsLink={false}
      >
        <SolutionsLightBlubDivComponent />
        <SolutionsSelect id="items" items={data?.solutions || []} />
      </ProfileForm>
    </ProfileEditorWrapper>
  )
}

export const SolutionsLightBlubDivComponent = () => (
  <LightBlubDiv>
    <img src={LIGHT_BLUB} alt="" />
    「ソリューション」とは、あなたが提供できる解決策やサービス、支援を指します。
    <br />
    例えば、特定の分野での専門知識を活かしたコンサルティングや、問題解決に向けたアドバイス、
    <br />
    リソースの提供など、あなたが他者に提供できるサポートを選択していただくことで、適切なマッチングが可能になります。
  </LightBlubDiv>
)

const LightBlubDiv = styled.div`
  background-color: ${_needs_form_light_blub};
  border-radius: 8px;
  padding: 20px;
  margin: 20px 20px;
  display: flex;
  align-items: center;
  font-weight: ${fontWeightBold};
  font-size: 12px;
  color: ${mediumGray};

  img {
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }
`
